import cookie from "js-cookie";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { FaPhone, FaWhatsapp } from "react-icons/fa";
import swal from "sweetalert";
import { getIntouch } from "../../../api.services.js/others";
import config from "../../../config";
import { useCounterStore } from "../../../store/useConterStore";
import AddressAutocomplete from "../address";
import { GetInTouchModal, uploadAudio } from "../forms/get-in-touch";
import GetInTouchPopUp from "../forms/get-in-touch-pop-up";
import RequestCallbackForm from "../forms/request-callback";
import Link from "next/link";
const Footer = (props) => {
  const router = useRouter();

  const isAdhesivesPage = router.asPath.includes("/masterbond-tile-adhesive");

  const { sidePromptModal, setSidePromptModal, _hasHydrated } =
    useCounterStore();

  const [TimePopup, setTimePopup] = useState(false);
  const [getInTouch, setGetInTouch] = useState(false);
  const [tarrekImage, settarrekImage] = useState(false);
  const [LocationPopop, setLocationPopop] = useState(
    cookie.get("skipLocationTimeBestPrice") ? false : true
  );
  const [timeOutIDS, settimeOutIDS] = useState([]);

  const [isClassToggled, setIsClassToggled] = useState(Array(15).fill(false));
  const toggleClass = (index) => {
    const updatedStates = [...isClassToggled];
    updatedStates[index] = !updatedStates[index];
    setIsClassToggled(updatedStates);
  };

  const [touch, setTouch] = useState({
    name: "",
    number: "",
    pincode: cookie.get("pincode"),
    countryCode: "", // New property for country code
    error: "",
    loading: false,
    cc: "",
    email: "",
  });

  const shouldShowModal = _hasHydrated ? sidePromptModal : false;

  /**
   * submitGetInTouch function is used to send the form data to the server and
   * store the lead in the database.
   * @param {string} subsource - Source of the lead (e.g. GetInTouch, GetInTouchPopUp)
   * @param {object} payload - Form data
   * @param {string} formType - Type of the form (GetInTouch or GetInTouchPopUp)
   */
  const submitGetInTouch = async (subsource, payload = null, formType) => {
    try {
      let response = await getIntouch({
        name: payload.name,
        phone: payload.number,
        pincode: payload.pincode,
        email: payload.email,
        call_id: subsource,
      });
      if (response?.data?.get_in_touch?.lead_id) {
        localStorage.setItem("leadfilled", true);
        formType === "GetInTouch" &&
          uploadAudio(
            response?.data?.get_in_touch?.lead_id,
            payload.audioBlob,
            payload.recordedText
          );

        handleClick();
        setGetInTouch(false);
        settarrekImage(false);
        localStorage.setItem("TarikClosed", true);
        swal("Success", "Your details have been submitted!", "success");
      } else throw new Error("Server Error");
    } catch (error) {
      console.error("Error submitting form:", error);
      swal("Error", "Something went wrong. Please try again later.", "error");
      throw error;
    }
  };

  const handleClick = () => {
    setSidePromptModal(!sidePromptModal);
    timeOutIDS.forEach((id) => clearTimeout(id));
  };

  let setleadpopop = () => {
    const startTimeString = localStorage.getItem("startTime");
    let startTime =
      startTimeString &&
      new Date(startTimeString).toLocaleDateString() ==
        new Date().toLocaleDateString()
        ? new Date(startTimeString)
        : new Date();
    const elapsedTime = new Date() - startTime;

    let arrr = [];
    // if (localStorage.getItem("leadSkiped")) return;
    if (elapsedTime < 30000 && !props?.catalougePage) {
      arrr.push(
        setTimeout(() => {
          if (!localStorage.getItem("leadfilled")) {
            setTimePopup(true);
            setGetInTouch(true);
          }
        }, 30000 - elapsedTime)
      );
    } else if (elapsedTime < 60000 && !props?.catalougePage) {
      arrr.push(
        setTimeout(() => {
          if (!localStorage.getItem("leadfilled")) {
            setTimePopup(true);
            setGetInTouch(true);
          }
        }, 60000 - elapsedTime)
      );
    } else if (elapsedTime < 120000 && !props?.catalougePage) {
      arrr.push(
        setTimeout(() => {
          if (!localStorage.getItem("leadfilled")) {
            setTimePopup(true);
            setGetInTouch(true);
          }
        }, 120000 - elapsedTime)
      );
    } else if (elapsedTime < 300000 && !props?.catalougePage) {
      arrr.push(
        setTimeout(() => {
          if (!localStorage.getItem("leadfilled")) {
            setTimePopup(true);
            setGetInTouch(true);
          }
        }, 300000 - elapsedTime)
      );
    }
    settimeOutIDS(arrr);
    localStorage.setItem("startTime", startTime.toString());
  };
  const popoptarek = () => {
    if (document.referrer) {
      const referrerURL = new URL(document.referrer);
      if (referrerURL.hostname === window.location.hostname) {
      } else {
        setTimeout(() => {
          settarrekImage(true);
        }, 90000);
      }
    } else {
      setTimeout(() => {
        settarrekImage(true);
      }, 90000);
    }
  };

  useEffect(() => {
    if (cookie.get("skipLocationTimeBestPrice") === true)
      setLocationPopop(false);
  }, [cookie.get("skipLocationTimeBestPrice")]);

  useEffect(() => {
    if (
      !cookie.get("skipLocation") &&
      !cookie.get("pincode") &&
      props?.displayLocationPopop
    ) {
      // setLocationPopop(true);
    } else {
      setleadpopop();
      popoptarek();
    }
    const handleScroll = () => {
      const scrollPosition =
        window.scrollY || document.documentElement.scrollTop;

      // Check if the scroll position is greater than or equal to 1000px
      if (scrollPosition >= 1000 && !localStorage.getItem("schrollSkip")) {
        // setSidePromptModal(true);
      }
    };

    // Attach the event listener when the component mounts
    // window.addEventListener('scroll', handleScroll);

    // Clean up the event listener when the component unmounts
    return () => {
      // clearTimeout(alertAfter15Sec);
      // clearTimeout(alertAfter1Min);
      // clearTimeout(alertAfter2Min);
      // clearTimeout(alertAfter5Min)
    };
  }, []);
  return (
    <>
      <div
        className={
          shouldShowModal ? "right_sidebar_form active" : "right_sidebar_form"
        }
      >
        <GetInTouchPopUp handleClick={handleClick} />
        <div
          className="getintouch_siadebar"
          onClick={handleClick}
          style={{
            background:
              "linear-gradient(45deg, hsl(43, 74%, 49%), hsl(48, 100%, 67%), hsl(16, 100%, 59%))",
          }}
        >
          <div className="foot-icon-bx">
            {shouldShowModal ? (
              <img src="/black-cross.png" alt="cross" />
            ) : (
              <img
                src="https://images.orientbell.com/media/premuimFormImg.png"
                alt="get in touch"
              />
            )}
          </div>
          <p>Consult Us</p>
        </div>
      </div>
      {router.asPath == "/tile-exports" ||
      router.asPath == "/download-export-catalogue" ? (
        <div className="mobile_view_footericon">
          <div class="foot-info-col">
            <div class="foot-icon-bx">
              <a href="ttel:+91-9599770470" aria-level="phone">
                <FaPhone />
              </a>
            </div>
            <p>Phone</p>
          </div>
          <div class="foot-info-col" id="Whatsapp_button_mobile_footer">
            <div class="foot-icon-bx">
              <a
                href="https://wa.me/919599770470?text=Hi, I am interested in Orientbell Tiles. I am currently browsing https://www.orientbell.com/"
                target="_blank"
              >
                <FaWhatsapp />
              </a>
            </div>
            <p>Whatsapp</p>
          </div>
        </div>
      ) : (
        <div className="mobile_view_footericon">
          <div class="foot-info-col">
            <div class="foot-icon-bx">
              <a href="tel:1800 208 1015" aria-level="phone">
                <FaPhone />
              </a>
            </div>
            <p>Phone</p>
          </div>
          <div class="foot-info-col" id="Whatsapp_button_mobile_footer">
            <div class="foot-icon-bx">
              <a
                href="https://wa.me/918750733333?text=Hi, I am interested in Orientbell Tiles. I am currently browsing https://www.orientbell.com/"
                target="_blank"
              >
                <FaWhatsapp />
              </a>
            </div>
            <p>Whatsapp</p>
          </div>
        </div>
      )}
      <div class="mobile-foot-category-row" style={{ display: "none" }}>
        <div class="foot-info-col" id="Store_locator_mobile_footer">
          <a href="https://www.orientbell.com/store-locator">
            <svg
              width="18"
              height="17"
              viewBox="0 0 18 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.0052 0.981934V2.99216H1.0169V0.981934H17.0052ZM17.987 10.9863H17.0052V16.9703H14.995V10.9863H11.0213V16.9703H1.0169V10.9863H0.0351562V8.9761L1.0169 3.9739H17.0052L17.987 8.9761V10.9863ZM9.01106 14.96V10.9863H3.02712V14.96H9.01106Z"
                fill="#BFBFBF"
              />
            </svg>
            <span>Stores</span>
          </a>
        </div>
        <div class="foot-info-col" id="Catalogue_button_mobile_footer">
          <a
            href="https://www.orientbell.com/download-catalogue"
            aria-label="category"
          >
            <svg
              width="16"
              height="18"
              viewBox="0 0 16 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.414062 14.8092C0.414063 15.4723 0.677455 16.1082 1.1463 16.577C1.61514 17.0459 2.25102 17.3092 2.91406 17.3092H12.9141C13.5771 17.3092 14.213 17.0459 14.6818 16.577C15.1507 16.1082 15.4141 15.4723 15.4141 14.8092V6.33258C15.4137 5.66988 15.1502 5.03444 14.6816 4.56591L11.4916 1.37424C11.0227 0.905677 10.3869 0.642499 9.72406 0.642578H2.91406C2.25102 0.642578 1.61514 0.90597 1.1463 1.37481C0.677455 1.84365 0.414063 2.47954 0.414062 3.14258V14.8092ZM8.7474 8.97591C8.7474 8.7549 8.6596 8.54294 8.50332 8.38666C8.34704 8.23038 8.13508 8.14258 7.91406 8.14258C7.69305 8.14258 7.48109 8.23038 7.32481 8.38666C7.16853 8.54294 7.08073 8.7549 7.08073 8.97591V11.9642L6.00323 10.8867C5.84606 10.7349 5.63556 10.651 5.41706 10.6529C5.19856 10.6547 4.98955 10.7424 4.83505 10.8969C4.68054 11.0514 4.5929 11.2604 4.591 11.4789C4.5891 11.6974 4.6731 11.9079 4.8249 12.0651L7.3249 14.5651C7.48117 14.7213 7.69309 14.8091 7.91406 14.8091C8.13503 14.8091 8.34696 14.7213 8.50323 14.5651L11.0032 12.0651C11.155 11.9079 11.239 11.6974 11.2371 11.4789C11.2352 11.2604 11.1476 11.0514 10.9931 10.8969C10.8386 10.7424 10.6296 10.6547 10.4111 10.6529C10.1926 10.651 9.98206 10.7349 9.8249 10.8867L8.7474 11.9642V8.97591Z"
                fill="#BFBFBF"
              />
            </svg>
            <span>Catalogue</span>
          </a>
        </div>
      </div>
      <div className="review-Catalouge">
        <div className="container">
          <div className="d-catalog-row">
            {router.asPath.includes("/tile-exports") ||
            router.asPath.includes("/download-export-catalogue") ? (
              <a href={`${config.HEADLESS_BASE_URL}/download-export-catalogue`}>
                <img src="/brouchure.png" alt="Image" /> DOWNLOAD CATALOGUE
              </a>
            ) : isAdhesivesPage ? (
              <a
                style={{ cursor: "pointer" }}
                onClick={() => {
                  const link = document.createElement("a");
                  link.href = "/masterbond-booklet.pdf"; // path in the public folder
                  link.download = "OBL Maserbond Booklet.pdf"; // filename when downloaded
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }}
              >
                <img src="/brouchure.png" alt="Image" /> DOWNLOAD BOOKLET
              </a>
            ) : (
              <a href={`${config.HEADLESS_BASE_URL}/download-catalogue`}>
                <img src="/brouchure.png" alt="Image" /> DOWNLOAD CATALOGUE
              </a>
            )}
          </div>
        </div>
      </div>
      <div className="fromUs-section">
        <div className="container">
          <div className="ft-fromUs-row flex-class">
            <div className="fr-Title">
              Get Personalized Help Choosing Tiles for Your Space
            </div>
            <div className="us-form-col">
              <RequestCallbackForm />
            </div>
          </div>
        </div>
      </div>
      <footer>
        <div className="container">
          <div className="footer-main">
            <div className="footer-top flex-class">
              <div className="foot-col">
                <div
                  className={
                    isClassToggled[0] ? "f-heading active-link" : "f-heading"
                  }
                  onClick={() => toggleClass(0)}
                >
                  <h6>Tiles</h6>
                </div>
                <ul>
                  <li>
                    <a href="https://www.orientbell.com/tiles/floor-tiles">
                      Floor Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/wall-tiles">
                      Wall Tiles
                    </a>
                  </li>
                </ul>
                <div class="foot-box">
                  <div
                    className={
                      isClassToggled[16] ? "f-heading active-link" : "f-heading"
                    }
                    onClick={() => toggleClass(16)}
                  >
                    <h6>Locations</h6>
                  </div>
                  <ul>
                    <li>
                      <a href="https://www.orientbell.com/tiles/delhi">Delhi</a>
                    </li>
                    <li>
                      <a href="https://www.orientbell.com/tiles/mumbai">
                        Mumbai
                      </a>
                    </li>
                    <li>
                      <a href="https://www.orientbell.com/tiles/bangalore">
                        Bengaluru
                      </a>
                    </li>
                    <li>
                      <a href="https://www.orientbell.com/tiles/darjeeling">
                        Darjeeling
                      </a>
                    </li>
                    <li>
                      <a href="https://www.orientbell.com/tiles/alipurduar">
                        Alipurduar
                      </a>
                    </li>
                    <li>
                      <a href="https://www.orientbell.com/tiles/jangipur">
                        Jangipur
                      </a>
                    </li>
                    <li>
                      <a href="https://www.orientbell.com/tiles/raiganj">
                        Raiganj
                      </a>
                    </li>
                    <li>
                      <a href="https://www.orientbell.com/tiles/hyderabad">
                        Hyderabad
                      </a>
                    </li>
                    <li>
                      <a href="https://www.orientbell.com/tiles/chennai">
                        Chennai
                      </a>
                    </li>
                    <li>
                      <a href="https://www.orientbell.com/tiles/kolkata">
                        Kolkata
                      </a>
                    </li>
                    <li>
                      <a href="https://www.orientbell.com/tiles/lucknow">
                        Lucknow
                      </a>
                    </li>
                    <li>
                      <a href="https://www.orientbell.com/tiles/pune">Pune</a>
                    </li>
                    <li>
                      <a href="https://www.orientbell.com/tiles/bhopal">
                        Bhopal
                      </a>
                    </li>
                    <li>
                      <a href="https://www.orientbell.com/tiles/jabalpur">
                        Jabalpur
                      </a>
                    </li>
                    <li>
                      <a href="https://www.orientbell.com/tiles/indore">
                        Indore
                      </a>
                    </li>
                    <li>
                      <a href="https://www.orientbell.com/tiles/nagpur">
                        Nagpur
                      </a>
                    </li>
                    <li>
                      <a href="https://www.orientbell.com/tiles/coimbatore">
                        Coimbatore
                      </a>
                    </li>
                    <li>
                      <a href="https://www.orientbell.com/tiles/patna">Patna</a>
                    </li>
                    <li>
                      <a href="https://www.orientbell.com/tiles/ernakulam">
                        Ernakulam
                      </a>
                    </li>

                    <li>
                      <a href=" https://www.orientbell.com/tiles/narnaul">
                        Narnaul
                      </a>
                    </li>
                    <li>
                      <a href=" https://www.orientbell.com/tiles/mahendragarh">
                        Mahendragarh
                      </a>
                    </li>
                    <li>
                      <a href=" https://www.orientbell.com/tiles/sohna">
                        Sohna
                      </a>
                    </li>
                    <li>
                      <a href=" https://www.orientbell.com/tiles/nuh">Nuh</a>
                    </li>
                    <li>
                      <a href=" https://www.orientbell.com/tiles/noida">
                        Noida
                      </a>
                    </li>
                    <li>
                      <a href=" https://www.orientbell.com/tiles/gurugram">
                        Gurugram
                      </a>
                    </li>
                    <li>
                      <a href=" https://www.orientbell.com/tiles/pataudi">
                        Pataudi
                      </a>
                    </li>
                    <li>
                      <a href=" https://www.orientbell.com/tiles/bhiwadi">
                        Bhiwadi
                      </a>
                    </li>
                    <li>
                      <a href=" https://www.orientbell.com/tiles/manesar">
                        Manesar
                      </a>
                    </li>
                    <li>
                      <a href=" https://www.orientbell.com/tiles/dharuhera">
                        Dharuhera
                      </a>
                    </li>
                    <li>
                      <a href=" https://www.orientbell.com/tiles/farukhnagar">
                        Farukhnagar
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="foot-col">
                <div
                  className={
                    isClassToggled[1] ? "f-heading active-link" : "f-heading"
                  }
                  onClick={() => toggleClass(1)}
                >
                  <h6>Tiles by Area</h6>
                </div>
                <ul>
                  <li>
                    <a href="https://www.orientbell.com/tiles/bathroom-tiles">
                      Bathroom Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/kitchen-tiles">
                      Kitchen Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/parking-tiles">
                      Parking Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/elevation-tiles">
                      Elevation Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/bedroom-tiles">
                      Bedroom Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/outdoor-tiles">
                      Outdoor Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/terrace-tiles">
                      Terrace Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/living-room-tiles">
                      Living Room Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/balcony-tiles">
                      Balcony Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/swimming-pool-tiles">
                      Swimming Pool Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/porch-tiles">
                      Porch Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/office-tiles">
                      Office Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/pathway-tiles">
                      Pathway Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/dining-room-tiles">
                      Dining Room Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/commercial-tiles">
                      Commercial Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/bar-tiles">
                      Bar Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/restaurant-tiles">
                      Restaurant Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/hospital-tiles">
                      Hospital Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/accent-tiles">
                      Accent Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/automotive-tiles">
                      Automotive Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/school-tiles">
                      School Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/high-traffic-tiles">
                      High Traffic Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/step-stairs-tiles">
                      Stairs Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/pooja-room-tiles">
                      Pooja Room Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/large-tiles">
                      Large Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/slab-tiles">
                      Slab Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/tile-collection/gvt-anti-skid-inspire-safegrip">
                      GVT Anti Skid
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/kitchen-tiles/white-kitchen-tiles">
                      White Kitchen Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/kitchen-tiles/blue-kitchen-tiles">
                      Blue Kitchen Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/kitchen-tiles/green-kitchen-tiles">
                      Green Kitchen Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/kitchen-tiles/black-kitchen-tiles">
                      Black Kitchen Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/dolphin-tiles">
                      Dolphin Tiles
                    </a>
                  </li>
                </ul>
              </div>
              <div className="foot-col">
                <div
                  className={
                    isClassToggled[2] ? "f-heading active-link" : "f-heading"
                  }
                  onClick={() => toggleClass(2)}
                >
                  <h6>Tiles by Design</h6>
                </div>
                <ul>
                  <li>
                    <a href="https://www.orientbell.com/tiles/3d-tiles">
                      3d Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/wooden-tiles">
                      {" "}
                      Wooden Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/marble-tiles">
                      Marble Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/texture-tiles">
                      {" "}
                      Texture Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/mosaic-tiles">
                      Mosaic Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/granite-tiles">
                      Granite Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/stone-tiles">
                      {" "}
                      Stone Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/pattern-tiles">
                      Pattern Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/cement-tiles">
                      Cement Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/flower-tiles">
                      {" "}
                      Flower Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/travertine-tiles">
                      Travertine Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/slate-tiles">
                      {" "}
                      Slate Tiles{" "}
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/statuario-tiles">
                      Statuario Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/plain-tiles">
                      {" "}
                      Plain Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/onyx-tiles">
                      {" "}
                      Onyx Tiles{" "}
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/metallic-tiles">
                      Metallic Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/bottochino-tiles">
                      Bottochino Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/book-match-tiles">
                      Book Match Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/geometric-tiles">
                      Geometric Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/carrara-tiles">
                      Carrara Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/abstract-tiles">
                      {" "}
                      Abstract Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/monochrome-tiles">
                      Monochrome Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/stylized-tiles">
                      Stylized Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/brick-tiles">
                      Brick Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/hexagonal-tiles">
                      Hexagonal Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/limestone-tiles">
                      Limestone Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/wooden-plank-tiles">
                      Plank Tiles
                    </a>
                  </li>
                </ul>
              </div>
              <div className="foot-col">
                <div
                  className={
                    isClassToggled[3] ? "f-heading active-link" : "f-heading"
                  }
                  onClick={() => toggleClass(3)}
                >
                  <h6>Tiles by Type</h6>
                </div>
                <ul>
                  <li>
                    <a href="https://www.orientbell.com/tiles/vitrified-tiles">
                      Vitrified Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/ceramic-tiles">
                      Ceramic Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/porcelain-tiles">
                      Porcelain Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/designer-tiles">
                      Designer Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/anti-skid-tiles">
                      Anti Skid Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/digital-tiles">
                      {" "}
                      Digital Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/double-charge-tiles">
                      Double Charge Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/vitrified-tiles/gvt-tiles">
                      GVT Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/cool-tiles">
                      {" "}
                      Cool Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/highlighter-tiles">
                      Highlighter Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/vitrified-tiles/pgvt-tiles ">
                      PGVT Tiles{" "}
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/vitrified-tiles/full-body-vitrified-tiles">
                      Full Body Vitrified Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/vitrified-tiles/polished-vitrified-tiles">
                      Polished Vitrified Tiles{" "}
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/germ-free-tiles">
                      Germ Free Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/vitrified-tiles/dgvt-tiles">
                      DGVT Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/forever-tiles">
                      Scratch Free Tile(Forever Tile)
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/vitrified-tiles/digital-glazed-vitrified-tiles">
                      Double Glazed Vitrified Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/stain-resistant-tiles">
                      Stain Resistant Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/nano-tiles">
                      Nano Tiles
                    </a>
                  </li>
                  {/* <li><a href="https://www.orientbell.com/tiles/printed-double-charge-tiles">Printed Double Charge Tiles</a></li> */}
                  <li>
                    <a href="https://www.orientbell.com/tiles/non-digital-tiles">
                      {" "}
                      Non Digital Tiles
                    </a>
                  </li>
                  {/* <li><a href="https://www.orientbell.com/tiles/kerinox-tiles">Kerinox Tiles</a></li> */}

                  <li>
                    <a href="https://www.orientbell.com/tiles/anti-static-tiles">
                      Anti Static Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/carving-tiles">
                      Carving Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/gvt-endless-tiles">
                      GVT Endless Tiles
                    </a>
                  </li>
                </ul>
              </div>
              <div className="foot-col">
                <div
                  className={
                    isClassToggled[4] ? "f-heading active-link" : "f-heading"
                  }
                  onClick={() => toggleClass(4)}
                >
                  <h6>Tiles by Colour</h6>
                </div>
                <ul>
                  <li>
                    <a href="https://www.orientbell.com/tiles/terracotta-tiles">
                      Terracotta Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/white-tiles">
                      {" "}
                      White Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/black-tiles">
                      Black Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/grey-tiles">
                      Grey Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/chequered-tiles">
                      {" "}
                      Chequered Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/blue-tiles">
                      Blue Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/red-tiles">
                      {" "}
                      Red Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/green-tiles">
                      Green Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/beige-tiles">
                      Beige Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/ivory-tiles">
                      Ivory Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/yellow-tiles">
                      {" "}
                      Yellow Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/cream-tiles">
                      Cream Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/pink-tiles">
                      Pink Tiles
                    </a>
                  </li>
                  {/* <li><a href="https://www.orientbell.com/tiles/orange-tiles">Orange Tiles</a></li> */}
                  <li>
                    <a href="https://www.orientbell.com/tiles/light-tiles">
                      Light Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/dark-tiles">
                      Dark Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/purple-tiles">
                      {" "}
                      Purple Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/multi-colour-tiles">
                      {" "}
                      Multi Colour Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/wenge-tiles">
                      {" "}
                      Wenge Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/brown-tiles">
                      Brown Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/sandune-tiles">
                      {" "}
                      Sandune Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/black-and-white-tiles">
                      {" "}
                      Black and White Tiles
                    </a>
                  </li>
                </ul>
              </div>
              <div className="foot-col">
                <div
                  className={
                    isClassToggled[5] ? "f-heading active-link" : "f-heading"
                  }
                  onClick={() => toggleClass(5)}
                >
                  <h6>Tiles by Size</h6>
                </div>
                <ul>
                  <li>
                    <a href="https://www.orientbell.com/tiles/2x2-tiles">
                      600X600 mm Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/2x4-tiles">
                      600X1200 mm Tiles
                    </a>
                  </li>
                  {/* <li><a href="https://www.orientbell.com/tiles/4x4-tiles">4x4 Tiles</a></li> */}
                  <li>
                    <a href="https://www.orientbell.com/tiles/1x1-tiles">
                      300X300 mm Tiles
                    </a>
                  </li>
                  {/* <li><a href="https://www.orientbell.com/tiles/1200x2400-tiles"> 4x8 mm Tiles</a></li> */}
                  <li>
                    <a href="https://www.orientbell.com/tiles/300x600-tiles">
                      300x600 mm Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/395x395-tiles">
                      395x395 mm Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/300x450-tiles">
                      300x450 mm Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/200x1200-tiles">
                      200x1200 mm Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/800x800-tiles">
                      800x800 mm Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/inspire-xl-1200x1800">
                      800x1200 mm Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/800x1600-tiles">
                      {" "}
                      800x1600 mm Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/granalt-tiles">
                      {" "}
                      800x2400 mm Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/145x600-tiles">
                      {" "}
                      145x600 mm Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/195x1200-tiles">
                      {" "}
                      195x1200 mm Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/295x295-tiles">
                      295x295 mm Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/200x300-tiles">
                      {" "}
                      200x300 mm Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/250x375-tiles">
                      {" "}
                      250x375 mm Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/400x400-tiles">
                      {" "}
                      400x400 mm Tiles{" "}
                    </a>
                  </li>
                  {/* <li><a href="https://www.orientbell.com/tiles/148x600-tiles"> 148x600 mm Tiles</a></li> */}
                  <li>
                    <a href="https://www.orientbell.com/tiles/1000x1000-tiles">
                      1000x1000 mm Tiles
                    </a>
                  </li>
                </ul>
              </div>
              <div className="foot-col">
                <div
                  className={
                    isClassToggled[6] ? "f-heading active-link" : "f-heading"
                  }
                  onClick={() => toggleClass(6)}
                >
                  <h6>Tiles by Finish</h6>
                </div>
                <ul>
                  <li>
                    <a href="https://www.orientbell.com/tiles/matte-finish-tiles">
                      Matte Finish Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/glossy-tiles">
                      Glossy Tiles
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/sugar-finish-tiles">
                      Sugar Finish Tiles
                    </a>
                  </li>
                  {/* <li><a href="https://www.orientbell.com/tiles/satin-finish-tiles">Satin Finish Tiles</a></li> */}
                  <li>
                    <a href="https://www.orientbell.com/tiles/super-glossy-tiles">
                      Super Glossy Tiles
                    </a>
                  </li>
                  {/* <li><a href="https://www.orientbell.com/tiles/reactive-tiles">Reactive Tiles</a></li> */}
                  {/* <li><a href="https://www.orientbell.com/tiles/lapato-finish-tiles">Lapato Finish Tiles</a></li> */}
                </ul>
                <div className="foot-box">
                  <div
                    className={
                      isClassToggled[7] ? "f-heading active-link" : "f-heading"
                    }
                    onClick={() => toggleClass(7)}
                  >
                    <h6>Tiles Collection</h6>
                  </div>
                  <ul>
                    <li>
                      <a href="https://www.orientbell.com/tiles/tile-collection/sparkle">
                        Sparkle Tiles Collection
                      </a>
                    </li>
                    <li>
                      <a href="https://www.orientbell.com/tiles/tile-collection/estilo">
                        Estilo Tiles Collection
                      </a>
                    </li>
                    <li>
                      <a href="https://www.orientbell.com/tiles/tile-collection/ft-autumn2020">
                        FT Autumn 2020 Tiles Collection
                      </a>
                    </li>
                    {/* <li><a href="https://www.orientbell.com/tiles/tile-collection/zenith">Zenith Tiles Collection</a></li> */}
                    <li>
                      <a href="https://www.orientbell.com/tiles/tile-collection/sahara">
                        Sahara Tiles Collection
                      </a>
                    </li>
                    <li>
                      <a href="https://www.orientbell.com/tiles/tile-collection/rhino-series-pavers-tiles">
                        Rhino Tiles Collection
                      </a>
                    </li>
                    <li>
                      <a href="https://www.orientbell.com/tiles/tile-collection/duazzle">
                        Duazzle Tiles Collection
                      </a>
                    </li>
                    <li>
                      <a href="https://www.orientbell.com/tiles/tile-collection/inspire">
                        Inspire Tiles Collection
                      </a>
                    </li>
                    <li>
                      <a href="https://www.orientbell.com/tiles/tile-collection/hd-p-elevation">
                        HD-P Elevation Tiles Collection
                      </a>
                    </li>
                    <li>
                      <a href="https://www.orientbell.com/tiles/tile-collection/inspire-planks">
                        Inspire Planks Tiles Collection
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="foot-box">
                  <div
                    className={
                      isClassToggled[15] ? "f-heading active-link" : "f-heading"
                    }
                    onClick={() => toggleClass(15)}
                  >
                    <h6>Tools</h6>
                  </div>
                  <ul>
                    <li>
                      <a href={`${config.HEADLESS_BASE_URL}/tile-calculator`}>
                        Tile Calculator
                      </a>
                    </li>
                    <li>
                      <a
                        href={`${config.HEADLESS_BASE_URL}/area-conversion-calculator`}
                      >
                        Area Calculator
                      </a>
                    </li>
                    <li>
                      <a href={`${config.HEADLESS_BASE_URL}/paint-calculator`}>
                        Paint Calculator
                      </a>
                    </li>
                    <li>
                      <a
                        href={`${config.HEADLESS_BASE_URL}/construction-cost-calculator`}
                      >
                        Cost Estimator
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="footer-top ft-bottom flex-class">
              <div className="foot-col">
                <div
                  className={
                    isClassToggled[8] ? "f-heading active-link" : "f-heading"
                  }
                  onClick={() => toggleClass(8)}
                >
                  <h6>About Us</h6>
                </div>
                <ul>
                  <li>
                    <a href="https://www.orientbell.com/about-us">
                      Who are we?
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/investor">
                      Investors Relation
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/career">Careers</a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/press-release">Media</a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/sustainability">
                      Sustainability
                    </a>
                  </li>
                </ul>
              </div>
              <div className="foot-col">
                <div
                  className={
                    isClassToggled[9] ? "f-heading active-link" : "f-heading"
                  }
                  onClick={() => toggleClass(9)}
                >
                  <h6>Useful links</h6>
                </div>
                <ul className="smooth-check 12">
                  <li>
                    <a href="https://www.orientbell.com/contact-us">
                      Contact us
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/faq">FAQ</a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/store-locator">
                      Store Locator
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/site-map">Sitemap</a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/signature-company-showrooms">
                      Signature Company Showrooms
                    </a>
                  </li>
                  <li>
                    <a href="https://stores.orientbell.com">
                      Orientbell Tiles Boutique Locator
                    </a>
                  </li>
                </ul>
              </div>
              <div className="foot-col">
                <div
                  className={
                    isClassToggled[10] ? "f-heading active-link" : "f-heading"
                  }
                  onClick={() => toggleClass(10)}
                >
                  <h6>Solutions for</h6>
                </div>
                <ul>
                  <li>
                    <a href="https://www.orientbell.com/tile-selector">
                      Home Owners
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tiles/school-tiles">
                      Education
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/trulook">
                      Home Designing Solution
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/tile-buying">
                      Tile Buying Guide
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/blog">
                      Inspirations for you
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/blog/web-story/">
                      Web Stories
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/design-ideas/">
                      Design Ideas
                    </a>
                  </li>
                  <li>
                    <Link href="/masterbond-tile-adhesive">Tile Adhesive</Link>
                  </li>
                </ul>
              </div>
              <div className="foot-col foot-connect">
                <div
                  className={
                    isClassToggled[12] ? "f-heading active-link" : "f-heading"
                  }
                  onClick={() => toggleClass(12)}
                >
                  <h6>Connect with us</h6>
                </div>
                <ul className="Social-Icons flex-class">
                  <li>
                    <a
                      href="https://wa.me/918750733333?text="
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="https://88nbxydt.cdn.imgeng.in/media/wysiwyg/whatsapp.jpg"
                        alt="WhatsApp"
                        loading="lazy"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/orientbell/?hl=en"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="https://88nbxydt.cdn.imgeng.in/media/wysiwyg/insta-icon.png"
                        alt="instagram"
                        loading="lazy"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.facebook.com/OrientBellTiles/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="https://88nbxydt.cdn.imgeng.in/media/wysiwyg/facebook.jpg"
                        alt="Facebook"
                        loading="lazy"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/@OrientBellTiles"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="/youtube-icon.svg"
                        alt="youtube"
                        loading="lazy"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://in.pinterest.com/OrientbellTiles/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="/pinterest-icon.svg"
                        alt="pinterest"
                        loading="lazy"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/company/orientbellltd"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="https://88nbxydt.cdn.imgeng.in/media/wysiwyg/linkedIn.jpg"
                        alt="LinkedIn"
                        loading="lazy"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://twitter.com/OrientbellTiles"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        style={{ background: "#e6e6e6" }}
                        width="20px"
                        src="/icons8-x-logo.svg"
                        alt="Twitter"
                        loading="lazy"
                      />
                    </a>
                  </li>
                </ul>
                <div className="select-lang">
                  <label htmlFor="P9LngDdl" style={{ color: "#fffff1" }}>
                    Change Language
                  </label>
                  <select
                    id="P9LngDdl"
                    className="mobilelanguga"
                    onChange={(e) => {
                      if (e.target.value) {
                        router.push(e.target.value);
                      }
                    }}
                  >
                    <option value="">Select </option>
                    <option value={`https://orientbell.com/${router.asPath}`}>
                      English
                    </option>
                    <option
                      value={`https://hindi.orientbell.com/${router.asPath}`}
                    >
                      हिंदी
                    </option>
                    <option
                      value={`https://tamil.orientbell.com/${router.asPath}`}
                    >
                      தமிழ்
                    </option>
                  </select>
                </div>
              </div>
              <div className="foot-col cpaddress">
                <div
                  className={
                    isClassToggled[13] ? "f-heading active-link" : "f-heading"
                  }
                  onClick={() => toggleClass(13)}
                >
                  <h6>Corporate Office</h6>
                </div>
                <p>
                  Iris House, 16 Business Centre,Nangal Raya,
                  <br />
                  DDA Complex,New Delhi - 110046 (India)
                </p>
                <div className="telno">
                  Tel: <a href="tel:911147119100">+91-11-47119100</a>, -{" "}
                  <a href="tel:911147119200">47119200</a>
                </div>
                <div className="telno">
                  Email:{" "}
                  <a href="mailto:customercare@orientbell.com">
                    customercare@orientbell.com
                  </a>
                </div>
              </div>
              <div className="foot-col">
                <div
                  className={
                    isClassToggled[14] ? "f-heading active-link" : "f-heading"
                  }
                  onClick={() => toggleClass(14)}
                >
                  <h6>Policies</h6>
                </div>
                <ul>
                  <li>
                    <a href="https://www.orientbell.com/privacy-policy">
                      Privacy Policy
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/shipping-policy">
                      Shipping Policy
                    </a>
                  </li>
                  <li>
                    <a href="https://www.orientbell.com/return-and-refund-policy">
                      Returns &amp; Refund Policy
                    </a>
                  </li>
                </ul>

                <div className="maplocate">
                  <img
                    loading="lazy"
                    src="/footer-paymet2_1_1.webp"
                    alt="Image"
                  />
                </div>
                <div className="footer-badge-row">
                  <ul className="flex-class">
                    <li>
                      {" "}
                      <a
                        href="https://www.orientbell.com/media/pdf/GRIHA.pdf"
                        download
                      >
                        <img loading="lazy" src="/GRIHA.png" alt="Image" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.orientbell.com/quality-certificates">
                        <img loading="lazy" src="/CE-11.png" alt="Image" />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.orientbell.com/quality-certificates">
                        <img loading="lazy" src="/IS.png" alt="Image" />
                      </a>
                    </li>
                    <li>
                      {" "}
                      <a
                        href="https://www.orientbell.com/media/pdf/Orient_Bell_Ltd.pdf"
                        download
                      >
                        <img loading="lazy" src="/IGBC.png" alt="Image" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {tarrekImage && (
          <div className="get-in-touchpopup">
            <img
              src="/tareek_get_in_touch.avif"
              alt="tareek image"
              id="tareeq-figurine-view"
              onClick={(e) => {
                e.stopPropagation();
                setGetInTouch(true);
                settarrekImage(false);
              }}
              // onLoad={() => {
              
              //   if (typeof window !== "undefined") {
              //     window.dataLayer = window.dataLayer || [];
              //     window.dataLayer.push({
              //       event: "mkt-form-view",
              //       action: "shown", 
              //       popup_id: "tareeq-figurine-view",
              //     });
              //   }
              // }}
            />
            <div
              className="icon-close-black-icon"
              id="tareeq-figurine-view"
              onClick={(e) => {
                e.stopPropagation();
                settarrekImage(false);
                localStorage.setItem("TarikClosed", true);

                // Push dismissal event
                // if (typeof window !== "undefined") {
                //   window.dataLayer = window.dataLayer || [];
                //   window.dataLayer.push({
                   
                //     event: "mkt-form-view",
                //     action: "closed",
                //     popup_id: "tareeq-figurine-view"
                //   });
                // }
              }}
            >
              <img
                src="/close_round_icon.svg"
                alt="close icon"
                id="tareeq-figurine-view"
              />
            </div>
          </div>
        )}
      </footer>
      <div className="copy-right">
        Copyright © 2025 OrientBell, All rights reserved.
      </div>

      <GetInTouchModal
        show={getInTouch}
        onHide={() => {
          setTimePopup(false);
          setGetInTouch(false);
          localStorage.setItem("leadSkiped", true);
        }}
        TimePopup={TimePopup}
        submitGetInTouch={submitGetInTouch}
        touch={touch}
        setTouch={setTouch}
      />

      <Modal
        show={LocationPopop}
        className="pincode-popup-bx expert_assistance_modal"
        onHide={() => {
          cookie.set("skipLocation", true, {
            expires: 7,
            secure: true,
            sameSite: "Strict",
          });
          cookie.set("skipLocationTimeBestPrice", true, {
            expires: 7,
            secure: true,
            sameSite: "Strict",
          });
          setleadpopop();
          setLocationPopop(false);
          popoptarek();
        }}
      >
        <div className="main-location-popup">
          <Modal.Dialog>
            <Modal.Header closeButton>
              <div class="location-pop-section">
                <div class="location-icon-bx">
                  <img src="/location-icon.png" alt="location icon"></img>
                </div>
                <div class="location-text-bx">
                  {" "}
                  <Modal.Title>
                    Allow Your Location to get best prices in your area
                  </Modal.Title>
                </div>
              </div>
            </Modal.Header>
            <Modal.Body>
              <AddressAutocomplete
                setLocationPopop={setLocationPopop}
                setleadpopop={setleadpopop}
                settarrekImage={settarrekImage}
              />
            </Modal.Body>
            {/* <Modal.Footer>
              <Button variant="primary" onClick={() => handlePinSave()}>
                Submit
              </Button>
            </Modal.Footer> */}
          </Modal.Dialog>
        </div>
      </Modal>
    </>
  );
};

export default Footer;
